import React, { Component } from 'react';
import { Form, Button, Row, Col } from 'reactstrap';
import DefaultContainer from 'containers/defaultcontainer';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom'
import { toast } from 'react-toastify';
import History from 'components/history'
import TabGroup, { TabsType } from 'components/tabgroup';
import ConfirmDialog from 'components/confirmdialog';

class EditableForm extends Component {

  constructor(props) {
    super(props);
    this.shouldClose = null;

    this.state = {
      restoreVisible: false,
      historyOpened: false,
      wasReadOnly: false,
      isLoading: false
    };

    this.confirmDialog = React.createRef();
  }

  componentDidMount() {

    this.previousState = {};
    const mainForm = document.getElementById('mainForm');
    for (let index = 0; index < mainForm.elements.length; index++) {
      const element = mainForm.elements[index];
      this.previousState[element.id] = element.disabled || element.readOnly;
    }

    if (this.isDeleted() && this.state.historyOpened === false) {
      this.openHistory();
    }

    if (this.props.readOnly) {
      this.setReadOnly(true);
    }
  }

  isDeleted() {
    return this.props.location.search.includes('deleted');
  }

  handleSave() {

    if (this.props.canSubmit && !this.props.canSubmit()) {
      return;
    }

    this.setState({
      isLoading: true
    });

    this.props.onSave().then(data => {
      this.setState({
        isLoading: false
      });
      if (this.shouldClose) {
        this.props.history.goBack();
      } else {
        toast.success('Saved successfully!');
        if (data) {
          this.props.history.replace(data);
        }
      }
    }).catch(() => {
      this.setState({
        isLoading: false
      });
    });

  }

  handleInvalid() {
    toast.error('Could not save! Some required fields have been left blank.');
  }

  handleDelete() {

    this.confirmDialog.current.show().then(() => {

      this.setState({
        isLoading: true
      });

      this.props.onDelete().then(() => {
        this.setState({
          isLoading: false
        });
        this.props.history.goBack();
      }).catch(() => {
        this.setState({
          isLoading: false
        });
      });

    });


  }

  setShouldClose(close) {
    this.shouldClose = close;
  }

  restoreVisible(history) {
    const action = history.action.toUpperCase();
    if (action === "DELETED") {
      return true;
    }
    return (history.current === false || history.current === undefined) && (action === "RESTORED" || action === "CREATED" || action === "UPDATED")
  }

  historySelectedChange = (selected) => {
    this.setState({
      restoreVisible: this.restoreVisible(selected)
    });

    this.props.onHistorySelectedChange(selected);
  }

  setReadOnly(isReadOnly) {
    this.props.onReadOnlyStateChanged && this.props.onReadOnlyStateChanged(isReadOnly);

    const mainForm = document.getElementById('mainForm');
    for (let index = 0; index < mainForm.elements.length; index++) {
      const element = mainForm.elements[index];
      if (element) {
        if (element.id === 'editable-form-btn-cancel') {
          continue; //skip
        }
        this.previousState[element.id] = element.disabled || element.readOnly;
        element.disabled = element.readOnly = isReadOnly;
      }
    }

  }

  openHistory = () => {
    this.props.onHistoryOpen();

    this.setState({
      restoreVisible: false,
      historyOpened: true,
      wasReadOnly: this.props.readOnly
    });

    if (!this.state.wasReadOnly) {
      this.setReadOnly(true);
    }
  }

  closeHistory() {
    if (this.isDeleted()) {
      this.props.history.goBack();
      return;
    }

    this.setState({
      restoreVisible: false,
      historyOpened: false,
      wasReadOnly: null
    });

    if (!this.state.wasReadOnly) {
      this.setReadOnly(false);
    }

    this.props.onHistoryClose();
  }

  renderHistory() {
    if (this.state.historyOpened) {
      return (<History {...this.props} onHistorySelectedChange={this.historySelectedChange} onHistoryClose={this.closeHistory.bind(this)} />);
    }
    return;
  }

  createTitleActions() {
    let actions = this.props.actions ? [...this.props.actions] : [];

    if (this.props.historyEnable
      && !this.state.historyOpened
      && !this.isDeleted()
      && this.props.match.params.id !== "new"
      && !this.props.location.search.includes('action=copy')
    ) {
      actions.push({
        label: "History",
        action: this.openHistory.bind(this)
      });
    }

    return actions;
  }

  renderTabs() {
    return (
      <Row>
        <Col xs="12" md="12" className="mb-3">
          <TabGroup tabs={this.props.tabs} onTabChanged={this.onTabChanged} activeTab={this.getLastOpenedTab()}/>
        </Col>
      </Row>
    )
  }

  isLoading() {
    return this.props.loading || this.state.isLoading;
  }

  onTabChanged(value) {
    EditableForm.setLastOpenedTab(value);
  }

  getLastOpenedTab() {
    let value = sessionStorage.getItem("last-opened-tab-form");
    return value !== null ? parseInt(value) : 0;
  }

  static setLastOpenedTab(value) {
    sessionStorage.setItem("last-opened-tab-form", value);
  }

  static clearStorageCache() {
    sessionStorage.removeItem("last-opened-tab-form");
  }

  render() {
    let colClass = "col-12 col-xl-12";
    if (this.state.historyOpened) {
      colClass = "col-12 col-xl-9";
    }

    return (
      <Row>
        <Col className={colClass}>
          <DefaultContainer
            {...this.props}
            actions={this.createTitleActions()}
            uriDoc={this.props.uriDoc}
          >
            <ConfirmDialog ref={this.confirmDialog} message="Do you want to delete this record?\nThis operation cannot be undone." />
            <Form id="mainForm"
              onInvalid={(event) => {
                this.onInvalidPromise && clearTimeout(this.onInvalidPromise);
                this.onInvalidPromise = setTimeout(this.handleInvalid);
                event.currentTarget.classList.add('was-validated');
                event.preventDefault();
                event.stopPropagation();
              }}
              onSubmit={(event) => {
                this.handleSave();
                event.preventDefault();
                event.stopPropagation();
              }}
            >

              {this.props.tabs && this.renderTabs()}

              {this.props.children}

              {this.props.footer && this.props.footer()}

              {!this.props.readOnly && this.props.onDelete &&
                (<Button onClick={this.handleDelete.bind(this)} color="danger" className="" disabled={this.isLoading()}>
                  Delete
                </Button>)
              }

              {this.props.customSubmitButton && (
                (<Button type="submit" onClick={() => this.setShouldClose(false)} color="primary" className="ml-2 float-right" id="save" disabled={this.isLoading()}>
                  {this.props.customSubmitButton}
                </Button>)
              )}

              {!this.props.customSubmitButton && (<>
                {!this.props.readOnly &&
                  (<Button type="submit" onClick={() => this.setShouldClose(true)} color="primary" className="ml-2 float-right" id="saveClose" disabled={this.isLoading()}>
                    Save & Close
                  </Button>)
                }
                {!this.props.readOnly &&
                  (<Button type="submit" onClick={() => this.setShouldClose(false)} color="primary" className="ml-2 float-right" id="save" disabled={this.isLoading()}>
                    Save
                  </Button>)
                }
                {!this.state.historyOpened &&
                  (<Button id="editable-form-btn-cancel" onClick={this.props.history.goBack} color="secondary" className="ml-2 float-right" disabled={this.isLoading()}>
                    {this.props.readOnly ? 'Back' : 'Cancel'}
                  </Button>)
                }
                {!this.state.wasReadOnly && this.state.historyOpened && this.state.restoreVisible &&
                  (<Button color="primary" className="ml-2 float-right" onClick={this.props.onRestore} disabled={this.isLoading()}>
                    Restore
                  </Button>)
                }
              </>)}

              {this.isLoading() && (
                <span className="spinner-border text-primary ml-2 float-right"></span>
              )}
            </Form>
          </DefaultContainer>
        </Col>
        {this.renderHistory()}
      </Row>
    );

  }
}

EditableForm.propTypes = {
  ...DefaultContainer.propTypes,
  ...History.propTypes,
  onSave: PropTypes.func.isRequired,
  onDelete: PropTypes.func,
  onRestore: PropTypes.func,
  canSubmit: PropTypes.func,
  historyEnable: PropTypes.bool,
  onReadOnlyStateChanged: PropTypes.func,
  onHistoryClose: PropTypes.func,
  footer: PropTypes.func,
  tabs: TabsType,
  loading: PropTypes.bool,
  customSubmitButton: PropTypes.string
}

EditableForm.defaultProps = {
  historyEnable: false,
  readOnly: false
}

export default withRouter(EditableForm);
